import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-9">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">关于我们</h2>
        </div>
        <div className="max-w-3xl mx-auto bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-10">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="flex-1">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-4">
                {aboutInfo.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {aboutInfo.desc}
              </p>
            </div>
            <div className="flex md:flex-col gap-4 md:gap-6 shrink-0">
              {aboutInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}